import { Component, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { AuthService } from './shared/auth.service';
import { Router, NavigationEnd } from '@angular/router';
import { environment } from 'src/environments/environment';

// tslint:disable-next-line: ban-types
declare let gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnDestroy {
  userName = '';
  userEmail = '';
  isSignedIn$: BehaviorSubject<boolean>;

  private subscriptions = new Subscription();

  constructor(private authService: AuthService,
              private router: Router) {
    this.isSignedIn$ = this.authService.isSignedIn$;
    this.subscriptions.add(this.authService.getUser().subscribe(user => {
      if (user) {
        this.userName = user.name;
        this.userEmail = user.email;
      } else {
        this.userName = '';
        this.userEmail = '';
      }
    }));

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        gtag('config', environment.googleTrackingID,
          {
            page_path: event.urlAfterRedirects
          });
      }
    });
  }

  signOut() {
    this.authService.signOut();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
